<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify Flexalign">
      <div class="content flex flexcolumn Flexalign">
        <el-image
          class="pay_success_img"
          :src="iconPath('pay_success_img.png')"
        ></el-image>
        <div class="pay_text">购买成功</div>
        <div class="pay_account">购买账号：{{ userInfo.name }}</div>
        <div class="pay_account">订单编号：{{ orderId }}</div>
        <div class="pay_text follow_text">关乎冠军高考专家辅导课服务号</div>
        <div class="flex Flexalign Flexjustify qrcode_box">
          <div class="qr_code_box flex flexcolumn Flexjustify Flexalign">
            <el-image
              class="weibo_white_icon cursor_pointer"
              :src="imgPath('guanjun_public_qrcode.jpg')"
              :preview-src-list="[imgPath('guanjun_public_qrcode.jpg')]"
            ></el-image>
          </div>
          <div class="qr_code_box mar_left_20 flex flexcolumn Flexjustify Flexalign">
            <el-image
              class="weibo_white_icon cursor_pointer"
              :src="imgPath('nishang_public_qrcode.jpg')"
              :preview-src-list="[imgPath('nishang_public_qrcode.jpg')]"
            ></el-image>
          </div>
        </div>
        <div class="mar_top_15 attention_text">
          扫一扫关注服务号、订阅开课、考试、 课程更新等重要通知
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
// import QrcodeVue from "qrcode.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5PaySuccess",
  components: {
    // QrcodeVue,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  data() {
    return {
      qrCodeValue: "qehgudufygqwigfdikdasj.akdajh",
      orderId: "",
      orderInfo: {},
    };
  },

  mounted() {
    this.orderId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).orderId;
    this.getOrderInfo();
  },

  methods: {
    getOrderInfo() {
      // this.$Api.shop.getOrderInfo(this.orderId).then((res) => {
      //   this.orderInfo = res.data.data;
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;
  .content {
    width: $pageMainWidth;
    min-height: calc(100vh - $pageTopHeight);
    .pay_success_img {
      width: 243px;
      height: 207px;
      margin-top: 50px;
    }
    .pay_text {
      font-weight: bold;
      font-size: 24px;
      color: #111111;
      margin-bottom: 20px;
    }
    .pay_account {
      margin-top: 10px;
      font-size: 18px;
      color: #666666;
    }
    .follow_text {
      margin-top: 80px;
    }
    .qrcode_box {
      // width: 164px;
      // height: 164px;
      background: #ffffff;
      border-radius: 10px;
      padding: 20px;
      .qr_code_box {
        width: 100px;
        height: 100px;
        background: #ffffff;
      }

      .weibo_white_icon {
        width: 98px;
        height: 98px;
      }
    }
    .attention_text {
      width: 294px;
      text-align: center;
      font-size: 18px;
      color: #999999;
      line-height: 30px;
    }
  }
}
</style>
